import { Spin } from 'antd';

import { useParams } from '@suntex.core/nav';
import { $ArithmeticOperation, ArithmeticOperation } from '@suntex.fim/enums';
import { getFlags } from '@suntex.fim/flags';
import { ComingSoon } from '@suntex.fim/player';
import { VifView, useVifData } from '@suntex.modules/vif';

import { ModuleLayout } from '../components/ModuleLayout';

import { SOUND_DIRECTORY, useModuleViewProps } from './shared';

function tryFromSlug<T>(
  ctx: { fromSlug: (slug: string) => T },
  slug: string | undefined,
): T | null {
  if (!slug) return null;
  try {
    return ctx.fromSlug(slug);
  } catch {
    return null;
  }
}

export function VIF() {
  const params = useParams<{ op: string; stage: string }>();
  const viewProps = useModuleViewProps();

  const operation = tryFromSlug($ArithmeticOperation, params.op);
  const passedStage = params.stage ? Number(params.stage) : 0;

  // Hooks must be called unconditionally; pass sentinels when invalid.
  const { loading, vifModule, title, subtitle, stage, maxAllowedStage } =
    useVifData({
      ...viewProps,
      operation: operation ?? ArithmeticOperation.Addition,
      stage: passedStage,
    });

  const classicRedirect = getFlags().classicRedirect.vif;

  if (operation === null || !Number.isInteger(passedStage) || passedStage < 0) {
    return <div>VIF game not found.</div>;
  }

  if (loading || !vifModule) {
    return <Spin />;
  }

  return (
    <ModuleLayout
      title={title}
      subtitle={subtitle}
      moduleId={vifModule.moduleId}
      alertMessage="If you are having trouble, try resetting your browser zoom to 100%."
    >
      {classicRedirect ? (
        <ComingSoon classicPath={`/modules/vif/${params.op}`}>
          <p>
            If you can&apos;t wait, you can still play VIF on the FIM classic
            website.
          </p>
          <p>This will open our classic site in a new tab.</p>
        </ComingSoon>
      ) : (
        <>
          <VifView
            {...viewProps}
            vifModule={vifModule}
            operation={operation}
            stage={stage}
            maxAllowedStage={maxAllowedStage}
            soundDirectory={SOUND_DIRECTORY}
          />
        </>
      )}
    </ModuleLayout>
  );
}
